import {
    sortOrderOfNodeAtFault,
    sortOrderOfLastCompletedBag,
    sortOrderOfLastCompletedFlight,
    sortOrderOfLastCompletedReflight,
    isTimeLineHealthy,
} from './nodeTimelineHelper';

function sortOrderOfBagIcon(timelineNodes) {
    if (isTimeLineHealthy(timelineNodes)) {
        return Math.max(
            sortOrderOfLastCompletedBag(timelineNodes),
            sortOrderOfLastCompletedFlight(timelineNodes)
        );
    }

    var timelineNodesFromLastReflight = timelineNodes.filter(
        (x) => x.sortOrder >= sortOrderOfLastCompletedReflight(timelineNodes)
    );

    return sortOrderOfNodeAtFault(timelineNodesFromLastReflight);
}

export default function nodeIconBuilder(timelineNodes) {
    return timelineNodes.map((node) => ({
        sortOrder: node.sortOrder,
        isLastBagNode: node.sortOrder === sortOrderOfBagIcon(timelineNodes),
    }));
}
